"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.n = (module)=>{
        var getter = module && module.__esModule ? ()=>module['default'] : ()=>module;
        __webpack_require__.d(getter, {
            a: getter
        });
        return getter;
    };
})();
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    default: ()=>VoiceControlButton_RealtimeInfoModal
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
require("react");
const external_pcln_design_system_namespaceObject = require("pcln-design-system");
const RealTimeVoiceModalInfo_js_namespaceObject = require("../../../Voice/RealTimeVoiceModalInfo.js");
var RealTimeVoiceModalInfo_js_default = /*#__PURE__*/ __webpack_require__.n(RealTimeVoiceModalInfo_js_namespaceObject);
const RealtimeInfoModal = ({ setShowRealTimeInfoModal, setShowVoiceTooltip, showRealTimeInfoModal })=>/*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Dialog, {
        ariaDescription: "Realtime Information Modal",
        ariaTitle: "Information about Realtime Voice Chat",
        borderRadius: "2xl",
        headerColorScheme: "neutralDarkOnLightest",
        onOpenChange: function(open) {
            setShowRealTimeInfoModal(open);
            setShowVoiceTooltip(open);
            if (!open) localStorage.setItem('userClosedVoiceModeTooltip', 'true');
        },
        overflowX: "auto",
        overflowY: "auto",
        scrimColor: "dark",
        scrimDismiss: true,
        showCloseButton: true,
        size: "md",
        open: showRealTimeInfoModal,
        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(RealTimeVoiceModalInfo_js_default(), {
            onContinue: function() {
                setShowRealTimeInfoModal(false);
                setShowVoiceTooltip(false);
                localStorage.setItem('userClosedVoiceModeTooltip', 'true');
            }
        })
    });
const VoiceControlButton_RealtimeInfoModal = RealtimeInfoModal;
exports["default"] = __webpack_exports__["default"];
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "default"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
